import { getValue } from "../../../common/getValue";

export function PPN_REQUEST(state) {
  state;
  state.ppn = {
    ...state.ppn,
    isLoading: true
  };
}
export function PPN_SUCCESS(state, payload) {
  const nominal = getValue(payload.data.data.rows[0], 'nominal', 0.0)
  const taxId = getValue(payload.data.data.rows[0], 'taxId', null)
  state.ppn = {
    data: {
      taxId,
      nominal
    },
    status: payload.status,
    isLoading: false
  };
}
export function PPN_ERROR(state, payload) {
  state;
  state.isLoading = false;
  state.error = true;
  state.errorMessage = payload;
}

export function UPDATE_PPN_REQUEST(state) {
  state;
  state.ppn = {
    ...state.ppn,
    isLoading: true
  };
}
export function UPDATE_PPN_SUCCESS(state, payload) {
  const nominal = getValue(payload.data.data.rows[0], 'nominal', 0.0)
  state;
  state.ppn = {
    data: {
      nominal: nominal
    },
    status: payload.status,
    isLoading: false
  };
}
export function UPDATE_PPN_ERROR(state, payload) {
  state;
  state.isLoading = false;
  state.error = true;
  state.errorMessage = payload;
}

export function UPDATE_PPN_NOMINAL (state, payload) {
  state.ppn.data = payload
}